define('momentFormats',['app','moment','momentLocale/fr'],function(app,moment){
    //
    // les traductions françaises "momentLocale/fr" sont inclues au build principal
    // pour des raisons de performance.
    // il est possible d'imaginer un build par langue, mais pour des raisons d'infra et de temps de compilation,
    // je préfère pour l'instant faire comme ça.
    //

    //
    // formatage des dates calendaires
    //
    var _DATETIME_ = 'Datetime';

    return {
        getFormats:function(){
            return {
                sameDay:function (now) {
                    var label;
                    // changement de service à 16h
                    if (this.isBefore(moment(now).floor(24, 'hours').add(16, 'h'))) {
                        label = '[ce midi à] HH:mm';
                    } else {
                        label = '[ce soir à] HH:mm';
                    }
                    return app.t(label,_DATETIME_);
                }
            ,
                nextDay:function (now) {
                    var label;
                    // changement de service à 16h
                    if (this.isBefore(moment(now).startOf('d').add(24+16, 'h'))) {
                        label = '[demain midi à] HH:mm';
                    } else {
                        label = '[demain soir à] HH:mm';
                    }
                    return app.t(label,_DATETIME_);
                }
            ,
                sameElse: function(now) {
                    var label = '[le] Do MMMM YYYY [à] HH:mm';
                    if (this.isAfter(moment(now).startOf('y'))) {
                        label = '[le] Do MMMM [à] HH:mm';
                    }
                    return app.t(label, _DATETIME_)
                }
            }
        }
    }
});
